<template>
  <panel class="pt-6 text-center">
    <i class="flex rounded-full mx-auto mb-6 border border-black w-16 h-16 items-center justify-center">
      <i class="fas fa-check fa-2x"></i>
    </i>

    <h3 class="mb-2">Thank you for your order</h3>
    <p>Your order will be processed and all the relevant parties will be contacted.</p>
    <p>You can check the progress of your order in the 'Order Progress / History' tab under 'Marketing Pack Services'</p>

    <hr class="border-b w-full my-6" />

    <h3 class="mb-2"><span v-if="selectedOffice.network_id !== 2">Enhanced Marketing </span>{{ pack.name }}</h3>
    <p>{{ order.delivery === 'digital' ? 'Digital' : 'Print' }} Delivery</p>
    <p v-if="order.requires_additional_epc">+ Additional EPC</p>
    <p class="font-bold text-lg mt-3">{{ priceTotal | gbp }}</p>

    <div v-if="order.payment_amount">
      <hr class="border-b my-6 w-1/2" />
      <p class="text-grey-darker">To be collected from vendor</p>
      <p class="font-bold text-lg">{{ order.payment_amount | gbp }}</p>
      <p class="mt-3" v-if="agentProfit > 0">You will be credited <strong class="text-green-dark">+ {{ agentProfit | gbp }}</strong></p>
    </div>

    <hr class="border-b my-6 w-1/2" />

    <div class="flex flex-wrap mx-auto">
      <span>Order Number: {{ receipt.id }}</span>
    </div>

    <div v-if="receipt.foundation_sum" class="flex justify-center text-left">
      <div class="w-full md:w-1/2 bg-grey-lightest border p-3 my-6 text-grey-darker">
        <div class="flex items-center -mx-3">
          <div class="w-1/3 px-3">
            <img src="/img/fc_foundation_black.png" alt="Fine & Country Foundation" class="block" />
          </div>
          <div class="w-2/3 px-3">
            In total, <strong class="text-black">{{ receipt.foundation_sum | gbp }}</strong> has been donated to the Fine & Country Foundation on your behalf. Thank you so much for your support.
          </div>
        </div>
      </div>
    </div>

  </panel>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['receipt', 'pack', 'order', 'priceTotal', 'agentProfit'],
  computed: {
    ...mapState(['selectedOffice'])
  }
}
</script>
